import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Category service for handling category operations
 */
export const categoryService = {
  /**
   * Get all categories
   * @returns {Promise<Array>} - Promise resolving to array of categories
   */
  getAll: async () => {
    const response = await apiClient.get(endpoints.categories.getAll);
    return response.data;
  },

  /**
   * Get all categories (alias for backward compatibility)
   * @returns {Promise<Array>} - Promise resolving to array of categories
   */
  getAllCategories: async () => {
    const response = await apiClient.get(endpoints.categories.getAll);
    return response.data;
  },

  /**
   * Get category by ID
   * @param {string} id - Category ID
   * @returns {Promise<Object>} - Promise resolving to category data
   */
  getCategoryById: async (id) => {
    const response = await apiClient.get(`${endpoints.categories.base}/${id}`);
    return response.data;
  },

  /**
   * Create a new category
   * @param {Object} categoryData - Category data
   * @param {string} categoryData.name - Category name
   * @param {string} [categoryData.description] - Category description (optional)
   * @param {string} [categoryData.parentCategoryId] - Parent category ID (optional)
   * @returns {Promise<Object>} - Promise resolving to created category
   */
  createCategory: async (categoryData) => {
    const response = await apiClient.post(endpoints.categories.base, categoryData);
    return response.data;
  },

  /**
   * Update an existing category
   * @param {string} id - Category ID
   * @param {Object} categoryData - Category data to update
   * @param {string} [categoryData.name] - Category name
   * @param {string} [categoryData.description] - Category description
   * @param {string} [categoryData.parentCategoryId] - Parent category ID
   * @returns {Promise<Object>} - Promise resolving to updated category
   */
  updateCategory: async (id, categoryData) => {
    const response = await apiClient.patch(`${endpoints.categories.base}/${id}`, categoryData);
    return response.data;
  },

  /**
   * Delete a category
   * @param {string} id - Category ID
   * @returns {Promise<Object>} - Promise resolving to success message
   */
  deleteCategory: async (id) => {
    const response = await apiClient.delete(`${endpoints.categories.base}/${id}`);
    return response.data;
  }
};
